module.exports = "pegasus_template/assets/theme2/twitter-icon-1.png";